import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/home-affordability',
  component: () => import('../../routes/HomeAffordability.svelte'),
  card: {
    id: 'home-affordability',
    title: 'Home Affordability',
    description: 'Calculate the maximum home price you can afford based on your income, debts, and expenses.',
    icon: 'real_estate_agent',
    iconBgClass: 'bg-pink-50',
    iconTextClass: 'text-pink-600',
    href: '/home-affordability',
    category: 'Real Estate',
  },
  seo: {
    title: 'Home Affordability Calculator – How Much House Can I Afford?',
    description: 'Free home affordability calculator to find how much house you can afford. Calculate your mortgage affordability, housing budget, and home price based on income, debts, and DTI ratio. Perfect for first time home buyers.',
  },
};

export default meta;
